import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c8613940&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c8613940&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=c8613940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8613940",
  null
  
)

export default component.exports